import React from 'react';

class GameTable extends React.Component {
    constructor(props) {
        super(props);
        this.onClickIndexChanged = this.onClickIndexChanged.bind(this);
        this.state = { clickIndex: 0 };
    }

    onClickIndexChanged(index) {
        this.setState({
            clickIndex: index
        });
    }

    render() {
        const thumbnailData = this.props.data.map(e => e.img);
        const detailData = this.props.data;

        return (
            <>
                <ThumbnailButtonList data={thumbnailData} onClick={this.onClickIndexChanged} clickIndex={this.state.clickIndex} />
                <Detail data={detailData[this.state.clickIndex]} />
            </>
        );
    }
}

class Detail extends React.Component {
    constructor(props) {
        super(props);
        this.handleButtonClick = this.handleButtonClick.bind(this);
    }

    handleButtonClick() {
        window.open(this.props.data.link);
    }

    render() {
        const name = this.props.data.name;
        const img = this.props.data.img;
        const description = this.props.data.description;
        const style = {
            width: '100%',
            height: '100%',
            display: 'flex',
            flexDirection: 'row'
        };
        const imgStyle = {
            width: '50%'
        };
        const contentStyle = {
            display: 'flex',
            flexDirection: 'column',
            width: '50%'
        }
        const textStyle = {
            textAlign: 'center'
        };
        const buttonStyle = {
            color: 'white',
            backgroundColor: 'green',
            fontSize: '24px',
            width: '50%',
            position: 'relative',
            left: '25%'
        };

        //This is a bad method to set html string
        //rel="noopener noreferrer": https://blog.csdn.net/weixin_38336658/article/details/84037213
        return (
            <div style={style} >
                <img style={imgStyle} src={img} alt={name} />
                <div style={contentStyle}>
                    <h3 style={textStyle}>{name}</h3>
                    <p style={textStyle} dangerouslySetInnerHTML={{ __html: description }}></p>
                    <button style={buttonStyle} onClick={this.handleButtonClick}>Download</button>
                </div>
            </div >
        )
    }
}

class ThumbnailButtonList extends React.Component {
    render() {
        const data = this.props.data;
        const onClick = this.props.onClick;
        const clickIndex = this.props.clickIndex;

        const items = data.map((datum, index) =>
            <ThumbnailButton key={index} img={datum} onClick={onClick} index={index} isClick={clickIndex === index} />
        );

        return (
            <div className="thumbnailButtonList">{items}</div>
        );
    }
}

class ThumbnailButton extends React.Component {//onmouseenter is better to write in css
    constructor(props) {
        super(props);
        this.handleClick = this.handleClick.bind(this);
    }

    handleClick() {
        this.props.onClick(this.props.index);
    }

    render() {
        const img = this.props.img;
        let className = "thumbnail";
        if (this.props.isClick) {
            className += " hasborder";
        }

        //TODO: check avaiable img import methods
        return (
            <img className={className} src={img} alt={img} onClick={this.handleClick}></img>
        );
    }
}

export default GameTable;